var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-section"},[_c('h3',{staticClass:"form-section-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-section-container",class:{ inline: _vm.inline }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }